// Store
////////
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
Vue.use(Vuex)

import jsonSurvey from '../assets/survey.json'
import quiz from '@/store/quiz';
import user from '@/store/user';
import lead from '@/store/lead';
import survey from '@/store/survey';
import settings from '@/store/settings';

const vuexPersist = new VuexPersist({
    key: 'okedito-contentscore',
    storage: localStorage
  })

const store = new Vuex.Store({
  state: {
    count: 10,

    // Airtable
    airtableWebApiBaseUrl: 'https://api.airtable.com/v0/appWpk3akH4zPHQUw/Users/',
    airtableApiUserEntryID: '',
    airtableTokenStr: 'keyTSlyuhV2CB7AYI',

    // Survey Variables
    surveyData: jsonSurvey,
    resultId: "ef2a6f3a-146b-446e-a832-7a6e265afd73", // SurveyJS
    surveyResult: {},
    surveyCategories: [],


    // User Answers and Scores
    userTotalScore: 0,
    surveyMaximumScore: 0,
  },

  plugins: [vuexPersist.plugin],

  modules: {
    quiz,
    user,
    survey,
    settings,
    lead,
  },

  getters: {
    userScorePercent: state => { return state.userTotalScore + state.surveyMaximumScore },

    surveyCategories: state => {
      // Extract category names
      var pageNames = [];
      for (var i = 0; i < state.surveyData.pages.length; i++) {
        pageNames.push(state.surveyData.pages[i].name);
      }
      return pageNames;
    }
  },

  mutations: {
    INCREMENT (state, incr=3) {
      state.count = state.count+incr
    },

    SET_SURVEY_RESULT(state, json_result) {
      // newNumber is the payload passed in.
      state.surveyResult = json_result;
    },

    SET_AIRTABLE_USER_ENTRY_ID(state, entry_id) {
      // newNumber is the payload passed in.
      state.airtableApiUserEntryID = entry_id;
    }
  },

  actions: {


    clearAll({ commit }){
      console.log("Clearing all store value");
      commit("quiz/RESET_NEW_QUIZ");
      commit("lead/RESET_STATE");
      commit("survey/RESET_STATE");
    },

    increment ({commit, state}, incr=2) {
      console.log("In Action ", state.count);
      commit('INCREMENT', incr);
      console.log("In Action ", state.count);
    },

    getSurveyAirtableResult ({commit, state}) {

      var endpoint = state.airtableWebApiBaseUrl + state.airtableApiUserEntryID;
      var bearer = "Bearer " + state.airtableTokenStr;

      axios.get(endpoint , {
        headers: {"Authorization" : bearer, "Content-type": "application/json"}
      }).then(function(response){
          commit('SET_SURVEY_RESULT', JSON.parse(response.data.fields.Answers));
          return Promise.resolve();
      }).catch( function(error){
          console.error("Error while fetching result from Airtable ", error);
      });
    },

    getSurveyJSResult ({commit, state}, clientID) { // deprecated
      // Get results from DX Survey to prefill survey for existing users
        axios.get("https://dxsurveyapi.azurewebsites.net/api/Survey/getResult", {
          params: {
            resultId: state.resultId,
            name: clientID
          }
        }).then(function(response){
            commit('SET_SURVEY_RESULT', response.data);
            console.log("WE GOT RESULT : ", response.data.QuestionResult);
            return Promise.resolve();
        }).catch( function(error){
            console.error("Error while fetching result ", error);
        });
    },
  }
});

export default store;




// WEBPACK FOOTER //
// ./src/store/index.js